import "./AsyncLoader.scss";

// Each div represents a circle animation.
// 1st scales from nothing to it's full size
// 2nd translates to the right from the same point as the 1st div
// 3rd translates to the right from the end position of the 2nd
// 4rd scales from it's original size to 0 (disappears)
function AsyncLoader(): JSX.Element {
    return (
        <div className="loadingEllipsis">
            <div />
            <div />
            <div />
            <div />
        </div>
    );
}

export { AsyncLoader };
